import { BREW_SPECS, BREW_STEPS, IMAGES } from "@/data/site";
import { Overline, Reveal } from "@/components/motion";

const BrewGuide = () => (
  <section
    id="brew-guide"
    data-testid="brew-guide-section"
    className="relative py-28 md:py-36"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-16 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <Reveal>
            <Overline>The Brew Guide</Overline>
            <h2 className="mt-5 font-serif text-4xl leading-[1.05] tracking-tight text-stone-100 sm:text-5xl lg:text-6xl">
              The ritual, <em className="not-italic text-amber-500">measured</em>
            </h2>
            <p className="mt-6 max-w-md text-base font-light leading-relaxed text-stone-400 md:text-lg">
              Good tea forgives. Great tea rewards precision. Three movements, a thermometer's
              honesty, and the patience to let the leaf speak.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="mt-12">
            <div className="group relative overflow-hidden border border-white/5">
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={IMAGES.spoons}
                  alt="Spoons of loose-leaf teas arranged on marble"
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-108"
                />
              </div>
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-stone-950/60 to-transparent" />
              <p className="absolute bottom-4 left-5 text-[10px] uppercase tracking-[0.35em] text-stone-300">
                One heaped spoon per cup
              </p>
            </div>
          </Reveal>
        </div>

        <div className="flex flex-col justify-center">
          <div className="space-y-10">
            {BREW_STEPS.map((s, i) => (
              <Reveal key={s.number} delay={i * 0.1}>
                <div className="flex gap-6 border-b border-white/5 pb-10">
                  <span className="font-serif text-5xl leading-none text-hollow-faint">{s.number}</span>
                  <div>
                    <h3 className="font-serif text-2xl tracking-tight text-stone-100">{s.title}</h3>
                    <p className="mt-2 text-sm font-light leading-relaxed text-stone-400 md:text-base">
                      {s.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2} className="mt-12">
            <p className="mb-4 text-[11px] uppercase tracking-[0.35em] text-amber-600">
              Steeping ledger
            </p>
            <div data-testid="brew-spec-table" className="divide-y divide-white/5 border-y border-white/5">
              {BREW_SPECS.map((row) => (
                <div
                  key={row.tea}
                  className="group grid grid-cols-[1fr_auto_auto] items-center gap-6 py-3.5 transition-colors duration-300 hover:bg-white/[0.02]"
                >
                  <span className="font-serif text-lg tracking-tight text-stone-200 transition-colors duration-300 group-hover:text-amber-400">
                    {row.tea}
                  </span>
                  <span className="w-16 text-right text-sm font-light text-stone-400">{row.temp}</span>
                  <span className="w-28 text-right text-sm font-light text-stone-400">{row.time}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default BrewGuide;
